import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { BranchYearDTO, IBranchYearDTO } from './branch.year.dto';
import { CriteriaDTO, ICriteriaDTO } from './criteria.dto';

export interface ICriteriaBranchYearDTO extends IBaseEntityDTO {
  branchYear?: IBranchYearDTO;
  criteria?: ICriteriaDTO;
  max_count: number;
}

export class CriteriaBranchYearDTO extends BaseEntityDTO implements ICriteriaBranchYearDTO {
  branchYear?: IBranchYearDTO;
  criteria?: ICriteriaDTO;
  max_count: number;

  constructor(data?: Partial<CriteriaBranchYearDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.max_count = data?.max_count ?? -1;
    this.branchYear = data?.branchYear ? new BranchYearDTO(data.branchYear) : undefined;
    this.criteria = data?.criteria ? new CriteriaDTO(data.criteria) : undefined;
  }
}
